import { FC, ReactNode } from "react";

import { Stack, Typography } from "@mui/material";

import { PageElementContainer } from "@components/PageContainer";

interface CaseStudyShortDescProps {
  desc: string;
  children: ReactNode;
}

export const CaseStudyShortDesc: FC<CaseStudyShortDescProps> = ({
  desc,
  children,
}) => {
  return (
    <PageElementContainer maxWidth="desktopXl" sx={{ pt: "40px", pb: "16px" }}>
      <Stack
        direction={{ sm: "column", md: "row" }}
        gap={"16px"}
        alignItems={"center"}
        m={{ sm: "16px", md: "32px", lg: "64px" }}
        mt={{ sm: "64px", lg: "100px" }}
      >
        <Typography variant="body" flex={1} order={{ sm: 2, md: 1 }}>
          {desc}
        </Typography>

        <div className="flex flex-col gap-4 items-center">
          <div className="grid gap-4 grid-cols-1 desktop:grid-cols-3">
            {children}
          </div>
        </div>
      </Stack>
    </PageElementContainer>
  );
};
